import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import DateFormatter from '../../../../components/Calendar/DateFormatter'
import Button from './Button'
import Flex from './Flex'

function RangePicker({
  startDate,
  finishDate,
  modifyWeek,
  size = 1,
  className,
  isChanging,
  print = false,
}: IRangePickerProps & IRangePickerDispatch) {
  return (
    <Flex
      size={size}
      justifyCenter={true}
      alignCenter={true}
      style={{
        fontSize: `${16 * size}px`,
        fontWeight: 500,
        marginRight: `${1.5 * size}em`,
      }}
      print={print}
    >
      <Button
        size={size}
        light={true}
        small={true}
        onClick={modifyWeek(-1)}
        left={true}
        className={`${className}-button-decrese`}
        isDisabled={isChanging}
      >
        <FiChevronLeft size={16 * size} />
      </Button>
      <Flex
        wrap={true}
        alignCenter={true}
        justifyCenter={true}
        style={{ padding: `0px ${24 * size}px`, pointerEvents: 'none' }}
        print={print}
      >
        <DateFormatter
          style={{ fontSize: `${16 * size}px` }}
          date={startDate}
          dateFormat={'D MMM'}
          className={`${className}-label-start`}
        />
        <div style={{ fontSize: `${16 * size}px` }}> -</div>
        <DateFormatter
          style={{ fontSize: `${16 * size}px` }}
          date={finishDate}
          dateFormat={'D MMM'}
          className={`${className}-label-finish`}
        />
      </Flex>
      <Button
        size={size}
        light={true}
        small={true}
        onClick={modifyWeek(1)}
        right={true}
        className={`${className}-button-increse`}
        isDisabled={isChanging}
      >
        <FiChevronRight size={16 * size} />
      </Button>
    </Flex>
  )
}

export default RangePicker

export interface IRangePickerProps {
  startDate: Date
  finishDate: Date
  className?: string
  isChanging: boolean
  size?: number
  print?: boolean
}

export interface IRangePickerDispatch {
  modifyWeek: (weeks: number) => () => void
}
